@if ((card?.template?.gameplay?.type??'') === 'numbers') {
  <div class="gameplay__container__box number__container">
    <mat-card class="card__container">
      <mat-card-content class="card__content">
      <nx-superprep-slide-panel [activePane]="activePane" [duration]="slideDuration">
          <div leftPane>
            <ng-container [ngTemplateOutlet]="numberTemplate"></ng-container>
          </div>
          <div rightPane [style.visibility]="(didAnswer && isAnswer) ? 'hidden' : 'visible'">
            <ng-container [ngTemplateOutlet]="numberTemplate"></ng-container>
          </div>
      </nx-superprep-slide-panel>
        @if (!didAnswer || question?.isImage) {
          <div [ngClass]="question?.isImage ? 'spacer-middle-small': 'spacer-middle'"></div>
        }
        @if (didAnswer && !question?.isImage) {
          <div
            [style.visibility]="(endText() && didAnswer && !isMultiple) ? 'visible' : 'hidden'"
            class="text__content endText"
            [innerHTML]="endText() | safe: 'html'"
          >
          </div>
        }
        <div class="simple-keyboard"></div>
        <div class="spacer-bottom"></div>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #numberTemplate>
  <div class="header__container">
    <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
  </div>
  <div class="media__container">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if (shouldShowQuestionText) {
    <div
      class="text__content"
      [ngClass]="didAnswer ? 'endText' : 'questionText'"
      [ngClass]="{ 'play': !didAnswer && question?.hasAudio }"
      [style.cursor]="!didAnswer && didPlayAudio ? 'pointer' : 'unset'"
      [innerHTML]="questionText() | safe: 'html'"
      (mousedown)="onPlayButtonTap()"
    ></div>
  }
  @if (shouldShowPlayButton) {
    <div class="audio__container lifted">
      <nx-superprep-play-button
          #audioButton
          [duration]="audioDuration"
          [diameter]="playButtonDiameter"
          (action)="onPlayButtonTap($event)"
        >
      </nx-superprep-play-button>
    </div>
  }
  @if (question?.isImage) {
    <div class="image__container">
      <img
        mat-card-img
        [ngClass]="didAnswer && isAnimationDone ? (isAnswer ? 'right' : 'wrong') : ''"
        [src]="question?.imageUrl"
      />
    </div>
  }
</ng-template>

<ng-template #inputTemplate>
  <div
    class="text__content"
    [@headShake]="didAnswer && !isAnswer"
    (@headShake.start)="onAnimationStart($event)"
    (@headShake.done)="onAnimationDone($event)"
  >
    @if (isMultiple) {
      @if (!didAnswer && isAnimationDone) {
        <span
          id="bottomText"
          [@fadeOutOnLeave]
          (@fadeOutOnLeave.start)="onAnimationStart($event)"
          (@fadeOutOnLeave.done)="onAnimationDone($event)"
          [innerHTML]="bottomText() | safe: 'html'"
        ></span>
      } @else if (isAnimationDone) {
        <span
          id="answerText"
          [@fadeInOnEnter]
          [innerHTML]="answerText() | safe: 'html'"
        ></span>
      }
    } @else {
      <input
        id="answerInput"
        class="input question"
        value="{{didAnswer && isAnimationDone ? answerValue : inputValue}}"
        [attr.disabled]="didAnswer ? 'disabled' : null"
        placeholder=""
        autofocus="true"
        inputmode="none"
        (input)="onInputChange($event)"
      />
    }
  </div>
</ng-template>
